import { render, staticRenderFns } from "./mafiaways.vue?vue&type=template&id=1ec07e5c&scoped=true"
import script from "./mafiaways.vue?vue&type=script&lang=js"
export * from "./mafiaways.vue?vue&type=script&lang=js"
import style0 from "./mafiaways.vue?vue&type=style&index=0&id=1ec07e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec07e5c",
  null
  
)

export default component.exports